import createSvgIcon from './utils/createSvgIcon';
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon([/*#__PURE__*/_jsx("path", {
  d: "M18 8h-3v2h3v11H6V10h3V8H6c-1.11 0-2 .89-2 2v11c0 1.1.89 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.11-.9-2-2-2z"
}, "0"), /*#__PURE__*/_jsx("path", {
  d: "M11 16h2V5h3l-4-4-4 4h3z"
}, "1")], 'IosShareTwoTone');